import { Module } from 'vuex-smart-module';
import RetroBonusesActions from './actions';
import RetroBonusesGetters from './getters';
import RetroBonusesMutations from './mutations';
import RetroBonusesState from './state';

export default new Module({
  state: RetroBonusesState,
  mutations: RetroBonusesMutations,
  actions: RetroBonusesActions,
  getters: RetroBonusesGetters,
});
